import React from "react";
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  CircularProgress,
  Button,
  IconButton,
  Checkbox,
  TablePagination,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useEffect } from "react";
import {
  getPartyMasterAccountWise,
  getTransactionDetails,
  getTransactionRelation,
  listAccountTransactionDetails,
  listAccountTransactionExtraDetails,
  listAccountTransactionLinkDetails,
  listPurchaseMaster,
  listTransactionMaster,
  listTransactionRelation,
} from "../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import { useState } from "react";
import { ArrowBackIosNewTwoTone } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteLinkToPayment from "./DeleteLinkToPayment";
import DeleteLinkToInvoice from "./DeleteLinkToInvoice";
import { MoneyFormat } from "../../library/MoneyFormat";
import { useThemes } from "../Theme/theme";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  // p: 4,
  outline: "none",
};

const headCell = [
  {
    id: "Invoice No:",
    label: "Invoice No:",
    minWidth: 100,
  },
  {
    id: "Invoice Date",
    label: "Invoice Date",
    minWidth: 100,
  },
  {
    id: "Invoice Amount",
    label: "Invoice Amount",
    minWidth: 100,
  },
  {
    id: "Balance in Invoice Voucher",
    label: "Balance in Invoice Voucher",
    minWidth: 140,
  },
  {
    id: "Linked Amount",
    label: "Linked Amount",
    minWidth: 100,
  },
  {
    id: "Current Balance",
    label: "Current Balance",
    minWidth: 100,
  },
  {
    id: "Action",
    label: "Action",
    minWidth: 40,
  },
];

function createData(
  no,
  date,
  amount,
  balanceinvocher,
  linkedAmount,
  currentBalance
) {
  return { no, date, amount, balanceinvocher, linkedAmount, currentBalance };
}

const rows = [createData("P1231/22-23", "16-05-2022", 10000, 10000, 10000, 0)];

const LinkToPurchaseInvoice = ({
  open,
  setOpen,
  accountID,
  setTransArr,
  entryData,
  showWarningSnackbar,
  setLinkedData,
  receiptDetails,
}) => {
  const { theme } = useThemes()

  const [rows, setRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [listAccountTransDetails, setListAccountTransDetails] = useState([]);
  const [selected, setSelected] = useState([]);
  const [usedAmount, setUsedAmount] = useState("");
  const [listTransRelatedData, setTransRealatedData] = useState([]);
  const [unUsedAmount, setUnUsedAmount] = useState("");
  const [allLinkedAmount, setAllLinkedAmount] = useState("");
  const [deleteLinkToPaymentModal, setDeletLinkToPaymentModal] =
    useState(false);
  const [paymentNo, setPaymentNo] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [invoiceID, setInvoiceID] = useState("");
  const [deleteEvent, setDeleteEvent] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [voucherLinkedAmount, setVoucherLinkedAmount] = useState("");
  const [transID, setTransID] = useState("");
  const [objectID, setObjectID] = useState("");
  const [objectAttribute, setObjectAttribute] = useState("");
  const [colIndex, setColIndex] = useState("");
  const [indexOfLinkAmount, setIndexOfLinkAmount] = useState(0)
  const [currentObj, setCurrentObj] = useState({
    BalanceInVoucher: 0,
    InvAmount: 0,
    LinkedAmount: 0,
  });
  const [state, setState] = useState({
    linkedAmount: "",
    balanceInVoucher: "",
  });
  const handleInputChange = (e, id, ind, balanceVoucher,
    invAmount,
    linkedAmount) => {
    rows.map((ele) => {
      if (ele.InvoiceID == id) {
        setState((prev) => ({
          ...prev,
          linkedAmount: e.target.value,
        }));
        ele.LinkedAmount = e.target.value;
      }
    });
    let totLinkedAmount = 0;
    setCurrentObj({
      BalanceInVoucher: balanceVoucher,
      PayAmount: invAmount,
      LinkedAmount: linkedAmount,
    });
    setColIndex(ind)
    rows.map((ele) => {
      totLinkedAmount += Number(ele.LinkedAmount);
    });
    setUsedAmount(totLinkedAmount);
    if (Object.keys(entryData).length > 0) {
      let UnUsedAmount = 0;
      if (entryData.RelatedTransactionDetails[0].CreditAmount == 0) {
        UnUsedAmount =
          Number(entryData.RelatedTransactionDetails[0]?.DebitAmount) -
          Number(totLinkedAmount);
      } else if (entryData.RelatedTransactionDetails[0].DebitAmount == 0) {
        UnUsedAmount =
          Number(entryData.RelatedTransactionDetails[0]?.CreditAmount) -
          Number(totLinkedAmount);
      }
      setUnUsedAmount(UnUsedAmount);
    } else {
      setUnUsedAmount(
        Number(receiptDetails.receivableAmount) - Number(totLinkedAmount)
      );
    }
  };
  useEffect(() => {
    if (colIndex !== "") {
      handleClick(page * rowsPerPage + (colIndex + 1));
    }
  }, [colIndex]);
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      let usedAmt = 0;
      let unusedAmt = 0;
      rows.map((ele) => {
        if (ele.Linked !== true) ele.LinkedAmount = "";
        unusedAmt = Number(paymentAmount) - Number(usedAmt);
      });
      if (unusedAmt > 0) {
        setUnUsedAmount(unusedAmt);
      } else {
        setUnUsedAmount(0);
      }
      setUsedAmount(usedAmt);
      setSelected([]);
      setState((prev) => ({
        ...prev,
        linkedAmount: "",
      }));
      setOpen(false);
    }
  };

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  const handleClick = (name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };
  useEffect(() => {
    let payment = 0;
    console.log("entydata", entryData);
    if (Object.keys(entryData).length > 0) {
      setPaymentNo(entryData.VoucherNumber);

      setPaymentAmount(
        entryData.RelatedTransactionDetails[0]?.DebitAmount == 0
          ? entryData.RelatedTransactionDetails[0]?.CreditAmount
          : entryData.RelatedTransactionDetails[0]?.DebitAmount
      );
    }
  }, [rows]);
  const saveLinkTranSaction = () => {
    let arr = [];
    let warningMsgArr = []
    rows.map((ele, ind) => {
      selected.map((subele) => {
        if (ind + 1 === subele) {
          arr.push(ele);
        }
      });
    });
    console.log("arr.......", arr);
    let filterArr = [];
    rows.filter((ele) => {
      if (ele.Linked != true) {
        filterArr.push(ele);
      }
    });
    // if (filterArr.length > 0) {
    //   if (selected.length == 0 && indexOfLinkAmount==0) {
    //     setWarningText("Please select the entry!");
    //     setWarningSnakbar(true);
    //   } else {
    //     let warningMsg = "";
    //     let isValid = false;
    //     let receiptAmount = 0;
    //     if (Object.keys(entryData).length > 0) {
    //       if (entryData?.RelatedTransactionDetails[0]?.DebitAmount == 0) {
    //         receiptAmount =
    //           entryData?.RelatedTransactionDetails[0]?.CreditAmount;
    //       } else {
    //         receiptAmount =
    //           entryData?.RelatedTransactionDetails[0]?.DebitAmount;
    //       }
    //     }

    //     arr.map((ele) => {
    //       if (
    //        ( Number(ele.BalanceInVoucher) < 0 &&
    //         Object.keys(entryData).length > 0 &&
    //         receiptAmount < usedAmount)  || receiptDetails.receivableAmount<usedAmount
    //       ) {
    //         // setWarningText("Insufficient Balance in Invoice Voucher! & Used Amount should be less than Invoice Amount!")
    //         // setWarningSnakbar(true)
    //         // setOpen(true)
    //         warningMsg =
    //           "Insufficient Balance in Invoice Voucher! & Used Amount should be less than Invoice Amount!";
    //         isValid = true;
    //       } else if (ele.BalanceInVoucher < 0 && ele.LinkedAmount == 0) {
    //         // setWarningText("Insufficient Balance in Invoice Voucher! & Linked Amount is Required")
    //         // setWarningSnakbar(true)
    //         // setOpen(true)
    //         warningMsg =
    //           "Insufficient Balance in Invoice Voucher! & Linked Amount is Required";
    //         isValid = true;
    //       } else if (
    //         Object.keys(entryData).length > 0 &&
    //         receiptAmount < usedAmount
    //       ) {
    //         // setWarningText("Used Amount should be less than Invoice Amount!")
    //         // setWarningSnakbar(true)
    //         // setOpen(true)
    //         warningMsg = "Used Amount should be less than Receipt Amount!";
    //         isValid = true;
    //       } else if (ele.BalanceInVoucher < 0) {
    //         // setWarningText("Failed to Link.Insufficient Balance in Invoice Voucher!")
    //         // setWarningSnakbar(true)
    //         // setOpen(true)
    //         warningMsg =
    //           "Failed to Link.Insufficient Balance in Invoice Voucher!";
    //         isValid = true;
    //       } else if (ele.LinkedAmount == 0) {
    //         // setWarningText("Linked Amount is Requird")
    //         // setWarningSnakbar(true)
    //         // setOpen(true)
    //         warningMsg = "Linked Amount is Requird";
    //         isValid = true;
    //       } else if (
    //         Number(ele.InvoiceAmount - usedAmount) <
    //         Number(indexOfLinkAmount) 
    //       ) {
    //         warningMsg = "Linked Amount should be less than Balance in Voucher";
    //         isValid = true;
    //       } else {
    //       }
    //     });
    //     if (isValid == true) {
    //       setWarningText(warningMsg);
    //       setWarningSnakbar(true);
    //       setOpen(true);
    //     } else {
    //       setTransArr(arr);
    //       setWarningSnakbar(false);
    //       setOpen(false);
    //     }
    //   }
    // }
    if (filterArr.length > 0) {
      if (selected.length == 0 && indexOfLinkAmount == 0) {
        showWarningSnackbar("Please select the entry!");
      } else {
        let isValid = false;
        if (receiptDetails.receivableAmount < usedAmount) {
          warningMsgArr.push("Used Amount should be less than Receipt Amount!");
          isValid = true;
        }
        if (indexOfLinkAmount == 0) {
          warningMsgArr.push("Linked Amount is Required");
          isValid = true;
        }
        if (currentObj.LinkedAmount !== 0 && currentObj.BalanceInVoucher < 0) {
          warningMsgArr.push(
            "Failed to Link.Insufficient Balance in Invoice Voucher!"
          );
          isValid = true;
        }
        if (
          currentObj.LinkedAmount !== 0 &&
          Number(currentObj.InvAmount - usedAmount) <
          Number(currentObj.LinkedAmount)
        ) {
          warningMsgArr.push(
            "Linked Amount should be less than Balance in Voucher"
          );
          isValid = true;
        } else {
        }
        if (isValid == true) {
          showWarningSnackbar(`${warningMsgArr}`);
          setOpen(true);
        } else {
          setTransArr(arr);
          setOpen(false);
        }
      }
    }
  };
  async function getTransactionData() {
    try {
      setBackdropOpen(true);
      let arr = [];
      const res = await API.graphql(
        graphqlOperation(getPartyMasterAccountWise, {
          AccountsID: accountID,
        })
      );
      if (res.data.getPartyMasterAccountWise !== null) {
        setListAccountTransDetails(res.data.getPartyMasterAccountWise);

        res?.data?.getPartyMasterAccountWise?.relatedInvoiceMaster.map(
          (ele) => {
            let from = new Date(Number(ele.InvoiceDate) * 1000);
            let fromyy = from.getFullYear();
            let frommm = from.getMonth() + 1;
            let fromdd = from.getDate();

            if (fromdd < 10) fromdd = "0" + fromdd;
            if (frommm < 10) frommm = "0" + frommm;

            ele.entryDate = fromyy + "-" + frommm + "-" + fromdd;
            ele.Checked = "";
            arr.push({
              InvoiceNumber: ele.InvoiceNumber,
              entryDate: ele.entryDate,
              InvoiceAmount: ele.InvoiceAmount,
              BalanceInVoucher: (
                Number(ele.InvoiceAmount).toFixed(2) -
                Number(voucherLinkedAmount).toFixed(2)
              ).toFixed(2),
              LinkedAmount: state.linkedAmount,
              InvoiceID: ele.InvoiceID,
              CurrentBalance: (
                Number(ele.InvoiceAmount).toFixed(2) -
                Number(voucherLinkedAmount).toFixed(2) -
                Number(state.linkedAmount).toFixed(2)
              ).toFixed(2),
            });
          }
        );

        setRows(arr);
        setBackdropOpen(false);
      } else {
        setBackdropOpen(false);
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  async function listTransactionRelatedData() {
    try {
      setBackdropOpen(true);
      let totLinkedAmount = 0;
      let linkedPayments = [];
      const res = await API.graphql(graphqlOperation(listTransactionRelation));
      setTransRealatedData(res.data?.listTransactionRelation);
      if (res.data.listTransactionRelation != null) {
        let AllLinkedAmountTotal = 0;
        res.data.listTransactionRelation.filter((ele) => {
          if (
            ele.TransactionTypeCD == "CashReceipt" ||
            ele.TransactionTypeCD == "BankReceipt"
          ) {
            AllLinkedAmountTotal += Number(ele.LinkedAmount);
            rows.map((subele) => {
              if (ele.ObjectID == subele.InvoiceID) {
                linkedPayments.push(subele);
                subele.Linked = true;
                subele.LinkedAmount = ele.LinkedAmount;
                subele.TransactionID = ele.TransactionID;
                subele.ObjectAttribute = entryData.VoucherNumber;
              }
            });
          }
        });
        let totPaymentLinkedAmount = 0;
        res.data.listTransactionRelation.map((ele) => {
          rows.map((subele) => {
            if (subele.InvoiceNumber === ele.ObjectAttribute) {
              totPaymentLinkedAmount += ele.LinkedAmount;
            }
          });
        });
        setVoucherLinkedAmount(totPaymentLinkedAmount);
        setLinkedData(linkedPayments);
        console.log("linkedPayments", linkedPayments);
        rows.map((ele) => {
          totLinkedAmount += Number(ele.LinkedAmount);
        });
        setAllLinkedAmount(AllLinkedAmountTotal);
        setUsedAmount(totLinkedAmount);
        if (Object.keys(entryData).length > 0) {
          let UnUsedAmount = 0;
          if (entryData.RelatedTransactionDetails[0].CreditAmount == 0) {
            UnUsedAmount =
              Number(entryData.RelatedTransactionDetails[0]?.DebitAmount) -
              Number(totLinkedAmount);
          } else if (entryData.RelatedTransactionDetails[0].DebitAmount == 0) {
            UnUsedAmount =
              Number(entryData.RelatedTransactionDetails[0]?.CreditAmount) -
              Number(totLinkedAmount);
          }
          setUnUsedAmount(UnUsedAmount);
        } else {
          setUnUsedAmount(
            Number(receiptDetails.receivableAmount) - Number(totLinkedAmount)
          );
        }
      }
      setBackdropOpen(false);
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    listTransactionRelatedData();
  }, [rows]);
  useEffect(() => {
    getTransactionData();
  }, [accountID, deleteEvent]);
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      // disableBackdropClick
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "10px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              {/* <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  lineHeight:"1.5"
                }}
              >
                Link to Invoices
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: "#fff",fontSize:"20px" }} />
                </IconButton>
              </Typography> */}
            </Box>
          </Box>

          <Box
            sx={{
              backgroundColor: "white",
              padding: "15px",
              height: { xs: "400px", sm: "auto" },
              overflowY: { xs: "scroll", sm: "hidden" },
              ".MuiTableCell-root": {
                padding: "10px 10px",
                fontSize: "13px",
              },
            }}
          >
            <Box sx={{ display: "flex" }}>
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    flex: 0.5,
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#888888",
                  }}
                >
                  Party Name : {receiptDetails.receivedFrom.label}
                </Typography>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    Receipt No
                  </Typography>
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    :{" "}
                    {paymentNo !== ""
                      ? paymentNo
                      : receiptDetails.vouchernumber}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    Receipt Amount
                  </Typography>
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    : ₹{" "}
                    {paymentAmount !== ""
                      ? MoneyFormat(Number(paymentAmount).toFixed(2), "en-IN")
                      : MoneyFormat(Number(receiptDetails.receivableAmount).toFixed(2), "en-IN")}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    Used Amount
                  </Typography>
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    : ₹ {MoneyFormat(Number(usedAmount).toFixed(2), "en-IN")}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    Unused Amount
                  </Typography>
                  <Typography
                    sx={{
                      flex: 0.5,
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#888888",
                    }}
                  >
                    : ₹ {MoneyFormat(Number(unUsedAmount).toFixed(2), "en-IN")}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: "400px",
              }}
            >
              <Table sx={{}} aria-label="simple table">
                <TableHead sx={{ color: theme.palette.secondary.main }}>
                  <TableRow>
                    <TableCell
                      padding="checkbox"
                      sx={{
                        ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root": {
                          padding: "5px",
                        },
                        backgroundColor: theme.palette.secondary.main,
                      }}
                    >
                    </TableCell>
                    {headCell.map((column, ind) => {
                      return (
                        <TableCell
                          key={ind}
                          width={column.width}
                          sx={{
                            backgroundColor: theme.palette.secondary.main,
                            color: "#FFF",

                          }}
                        >
                          {column.label}{" "}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stableSort(
                    rows.sort(function (a) {
                      if (a.Linked == true) {
                        return -1;
                      } else {
                        return 1;
                      }
                    }),
                    getComparator(order, orderBy)
                  )
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, ind) => {
                      const isItemSelected = isSelected(
                        page * rowsPerPage + (ind + 1)
                      );
                      const labelId = `enhanced-table-checkbox-${ind}`;
                      return (
                        <TableRow
                          key={ind}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                            backgroundColor:
                              row.Linked == true ? "#a3a0a01a" : "#fff",
                          }}
                        >
                          <TableCell
                            padding="checkbox"
                            sx={{
                              ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root":
                              {
                                padding: "5px",
                              },
                            }}
                          >
                            {row.Linked !== true && (
                              <Checkbox
                                value={page * rowsPerPage + (ind + 1)}
                                color="primary"
                                onClick={(event) => {
                                  handleClick(
                                    page * rowsPerPage + (ind + 1)
                                  );
                                  row.Checked = page * rowsPerPage + (ind + 1);
                                }}
                                checked={isItemSelected || row.LinkedAmount}
                                inputProps={{
                                  "aria-labelledby": labelId,
                                }}
                                size="small"
                              />
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: row.Linked == true ? "#20e0cf" : "#396afc",
                              minWidth: "100px",
                            }}
                            align="left"
                          >
                            {row.InvoiceNumber}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: row.Linked == true ? "#20e0cf" : "#396afc",
                              minWidth: "100px",
                            }}
                            align="left"
                          >
                            {row.entryDate}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: row.Linked == true ? "#20e0cf" : "#396afc",
                            }}
                            align="left"
                          >
                            ₹ {MoneyFormat(Number(row.InvoiceAmount).toFixed(2), "en-IN")}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: row.Linked == true ? "#20e0cf" : "#396afc",
                              minWidth: "100px",
                            }}
                            align="left"
                          >
                            ₹{" "}
                            {MoneyFormat((
                              Number(row.InvoiceAmount).toFixed(2) -
                              Number(row.LinkedAmount).toFixed(2)
                            ).toFixed(2), "en-IN")}
                          </TableCell>
                          <TableCell>
                            {row.Linked === true ? (
                              <Typography
                                sx={{
                                  minWidth: "150px",
                                  fontSize: "13px",
                                  color:
                                    row.Linked == true ? "#20e0cf" : "#396afc",
                                }}
                              >
                                ₹ {MoneyFormat(Number(row.LinkedAmount).toFixed(2), "en-IN")}
                              </Typography>
                            ) : (
                              <TextField
                                align="left"
                                sx={{
                                  minWidth: "150px",
                                  maxHeight: "0.1px",
                                  mb: 5,
                                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                  {
                                    color:
                                      row.Linked == true
                                        ? "#20e0cf"
                                        : "#396afc",
                                    height: "1.2em",
                                  },
                                }}
                                type="number"
                                placeholder="₹"
                                size="small"
                                value={row.LinkedAmount}
                                onChange={(e) => {
                                  setIndexOfLinkAmount(e.target.value)
                                  handleInputChange(e, row.InvoiceID, ind, row.BalanceInVoucher,
                                    row.InvoiceAmount,
                                    row.LinkedAmount)
                                }}
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                  },
                                }}
                                onKeyPress={(event) => {
                                  if (
                                    event?.key === "-" ||
                                    event?.key === "+"
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              ></TextField>
                            )}
                          </TableCell>
                          {/* <TableCell align="left">₹ {row.linkedAmount}</TableCell> */}
                          <TableCell
                            sx={{
                              color: row.Linked == true ? "#20e0cf" : "#396afc",
                              minWidth: "100px",
                            }}
                            align="left"
                          >
                            ₹{" "}
                            {MoneyFormat((
                              Number(row.InvoiceAmount - row.LinkedAmount).toFixed(2) -
                              Number(row.LinkedAmount).toFixed(2)
                            ).toFixed(2), "en-IN")}
                          </TableCell>
                          <TableCell align="left" sx={{ minWidth: "100px" }}>
                            <IconButton
                              aria-label="delete"
                              onClick={() => {
                                setDeletLinkToPaymentModal(true);
                                setInvoiceID(row.InvoiceID);
                                setObjectID(row.InvoiceID);
                                setObjectAttribute(row.ObjectAttribute);
                                setTransID(row.TransactionID);
                              }}
                              disabled={row.Linked !== true ? true : false}
                              sx={{
                                margin: "0px 2px",
                                padding: "5px",
                                backgroundColor: "#fff",
                              }}
                            >
                              <DeleteIcon
                                sx={{
                                  fontSize: "15px",
                                  color:
                                    row.Linked !== true
                                      ? "#c9c9c973"
                                      : "#eb6a6a",
                                }}
                              />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <TablePagination
            sx={{
              scrollbarWidth: "thin",
              "&::-webkit-scrollbar": {
                // width: '0.4em',
                height: "0.2em",
              },
              "&::-webkit-scrollbar-track": {
                background: `${theme.palette.primary.main}47`,
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "primary.main",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: `${theme.palette.primary.main}47`,
              },
            }}
            rowsPerPageOptions={[10, 20, 50]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          <Box
            sx={{
              // padding : "15px",
              // width:'100%',
              display: "flex",
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Button
              onClick={handleClose}
              variant="outlined"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              Cancel
            </Button>
            <Button
              onClick={saveLinkTranSaction}
              variant="contained"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              LINK
            </Button>
          </Box>
          <DeleteLinkToInvoice
            open={deleteLinkToPaymentModal}
            // setEntryRows={setFinancialYearDetails}
            setOpen={setDeletLinkToPaymentModal}
            rows={rows}
            setRows={setRows}
            setDeleteEvent={setDeleteEvent}
            ObjectAttribute={objectAttribute}
            ObjectID={objectID}
            TransID={transID}
            InvID={invoiceID}
          ></DeleteLinkToInvoice>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={backdropOpen}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </Box>
      </Fade>
    </Modal>
  );
};

export default LinkToPurchaseInvoice;
